export const suggestionColors = ([
    {
        points: ["#228ae6", "#12b886"]
    },
    {
        points: ["#114357", "#F29492"]
    },
    {
        points: ["#eacda3", "#d6ae7b"]
    },
    {
        points: ["#6a3093", "#a044ff", "#000954"]
    },
    {
        points: ["#B2FEFA", "#0ED2F7"]
    },
    {
        points: ["#D66D75", "#E29587"]
    },
    {
        points: ["#F0F2F0", "#000C40"]
    },
    {
        points: ["#c2e59c", "#64b3f4"]
    },
    {
        points: ["#CC95C0", "#DBD4B4", "#7AA1D2"]
    },
    {
        points: ["#D16BA5", "#86A8E7", "#5FFBF1"]
    },

    {
        "points": [
            "#FDEB71",
            "#F8D800"
        ]
    },
    {
        "points": [
            "#ABDCFF",
            "#0396FF"
        ]
    },
    {
        "points": [
            "#FEB692",
            "#EA5455"
        ]
    },
    {
        "points": [
            "#CE9FFC",
            "#7367F0"
        ]
    },
    {
        "points": [
            "#90F7EC",
            "#32CCBC"
        ]
    },
    {
        "points": [
            "#FFF6B7",
            "#F6416C"
        ]
    },
    {
        "points": ["#34787a", "#4ccfcb", "#59ddd8", "#8af2ef", "#c4fffd"]
    },
    {
        "points": ["#7b7477", "#e1d4da", "#f5e8f4", "#fefcff", "#eeebf5"]
    },
    {
        "points": ["#4c3c71", "#805fc3", "#a98bbb", "#c0b994", "#c7db78"]
    },
    {
        "points": ["#3a6b55", "#5fc198", "#9ed5ae", "#d6d3b8", "#fad1c1"]
    },
    {
        "points": ["#1e1f23", "#5c5d61", "#ffffff", "#ffe7cc", "#efc99d"]
    },
    {
        "points": ["#1d0c9c", "#7361fa", "#a9a9f5", "#bcf5be", "#025c05"]
    },
    {
        "points": [
            "#81FBB8",
            "#28C76F"
        ]
    },
    {
        "points": [
            "#E2B0FF",
            "#9F44D3"
        ]
    },
    {
        "points": [
            "#F97794",
            "#623AA2"
        ]
    },
    {
        "points": [
            "#FCCF31",
            "#F55555"
        ]
    },
    {
        "points": [
            "#F761A1",
            "#8C1BAB"
        ]
    },
    {
        "points": [
            "#43CBFF",
            "#9708CC"
        ]
    },
    {
        "points": [
            "#5EFCE8",
            "#736EFE"
        ]
    },
    {
        "points": [
            "#FAD7A1",
            "#E96D71"
        ]
    },
    {
        "points": [
            "#FFD26F",
            "#3677FF"
        ]
    },
    {
        "points": [
            "#A0FE65",
            "#FA016D"
        ]
    },
    {
        "points": ["#4c269a", "#e4d7ff", "#ffdfaf", "#f1884e", "#191c32"]
    },
    {
        "points": ["#5540fb", "#cbc4ff", "#f4f4f7", "#fb6b30", "#15192b"]
    },
    {
        "points": ["#071232", "#00a389", "#bfe8e1", "#edeff4", "#777d8e"]
    },
    {
        "points": ["#25282b", "#d3f26a", "#eae8e2", "#f7f6ef", "#ffffff"]
    },
    {
        "points": ["#6b2d5c", "#f0386b", "#ff5376", "#f8c0c8", "#e2c290"]
    },
    {
        "points": ["#0e1c36", "#afcbff", "#d7f9ff", "#f9fbf2", "#ffede1"]
    },
    {
        "points": ["#011c27", "#03254e", "#545677", "#eb9fef", "#fecee9"]
    },
    {
        "points": ["#990d35", "#d52941", "#fcd581", "#fff8e8", "#ffffff"]
    },
    {
        "points": ["#5ceea7", "#d1ffe9", "#ffffff", "#e8f1f1", "#0d067c"]
    },
    {
        "points": [
            "#FFDB01",
            "#0E197D"
        ]
    },
    {
        "points": [
            "#FEC163",
            "#DE4313"
        ]
    },
    {
        "points": [
            "#92FFC0",
            "#002661"
        ]
    },
    {
        "points": [
            "#EEAD92",
            "#6018DC"
        ]
    },
    {
        "points": [
            "#F6CEEC",
            "#D939CD"
        ]
    },
    {
        "points": [
            "#52E5E7",
            "#130CB7"
        ]
    },
    {
        "points": [
            "#F1CA74",
            "#A64DB6"
        ]
    },
    {
        "points": [
            "#E8D07A",
            "#5312D6"
        ]
    },
    {
        "points": [
            "#EECE13",
            "#B210FF"
        ]
    },
    {
        "points": [
            "#79F1A4",
            "#0E5CAD"
        ]
    },
    {
        "points": [
            "#FDD819",
            "#E80505"
        ]
    },
    {
        "points": [
            "#FFF3B0",
            "#CA26FF"
        ]
    },

    {
        "points": ["#f8ed82", "#fcf7ca", "#fffefa", "#cacefc", "#828cf7"]
    },
    {
        "points": ["#f6552d", "#fa9078", "#fcb9a9", "#75e2fa", "#2ed1f7"]
    },
    {
        "points": ["#e1b4b2", "#f6eae9", "#ffffff", "#e9f6f6", "#b3dee0"]
    },
    {
        "points": ["#474042", "#706468", "#8a7c81", "#65726d", "#404745"]
    },
    {
        "points": ["#c86246", "#f2957c", "#eabaa4", "#f7d7c8", "#fdf1e7"]
    },

    {
        "points": ["#52352b", "#b38e81", "#f4f4f7", "#f2e8d5", "#e8d9b7"]
    },
    {
        "points": ["#0c66a6", "#4ca0d4", "#cfeffa", "#fa8557", "#071657"]
    },
    {
        "points": ["#02a363", "#33e89a", "#c7f8ff", "#91dcff", "#0490bf"]
    },
    {
        "points": ["#d4c00b", "#faf3b4", "#fa7f5a", "#b03b17", "#5e1701"]
    },
    {
        "points": ["#3e5efa", "#94a9ff", "#dbdbff", "#ff8cb3", "#e91e63"]
    },
    {
        "points": ["#52352b", "#b38e81", "#f2e8d5"]
    },
    {
        "points": ["#0c66a6", "#4ca0d4", "#cfeffa", "#fa8557", "#071657"]
    },
    {
        "points": ["#02a363", "#33e89a", "#0490bf"]
    },
    {
        "points": ["#d4c00b", "#b03b17", "#5e1701"]
    },
    {
        "points": ["#3e5efa", "#94a9ff", "#e91e63"]
    },

]);